import lodashGet from 'lodash.get'

export default {
  updateOptions(
    { commit, dispatch, getters },
    { id = null, path = null, value = null, stack = 'undo', stackToClear = 'redo', pushUpdateToStack = true } = {}
  ) {
    if (!id) {
      return
    }

    const oldValue = lodashGet(getters.objectById(id), `options${path && `.${path}`}`)
    commit('updateOptions', { id, path, value })

    if (pushUpdateToStack) {
      dispatch(
        'history/pushToStack',
        {
          stack,
          action: 'landing/updateOptions',
          params: { id, path, value: oldValue },
          stackToClear,
        },
        { root: true }
      )
    }
  },

  updatePosition(
    { state, commit, dispatch, getters },
    { id = null, from = null, to = null, stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    if (!id || from === null || to === null) {
      return
    }

    const me = getters.objectById(id)
    const movingDown = to > from

    let mySiblingsIds = []

    if (me.type === 'Panel') {
      const parentId = me.path[me.path.length - 1]
      const parent = getters.objectById(parentId)
      mySiblingsIds = parent.children.filter(l => l !== id)
    } else if (['Section', 'Tabs', 'HeroSparkBanner'].includes(me.type)) {
      mySiblingsIds = getters
        .containers()
        .map(s => s.id)
        .filter(l => l !== id)
    }

    const siblings = mySiblingsIds
      .map(id => getters.objectById(id))
      .filter(sibling => {
        const position = sibling.options[state.currentView].position
        return movingDown ? position > from && position <= to : position < from && position >= to
      })
      .map(sibling => ({
        id: sibling.id,
        position: sibling.options[state.currentView].position + (movingDown ? -1 : +1),
      }))

    commit('updatePosition', [{ id, position: to }, ...siblings])

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/updatePosition',
        params: { id, from: to, to: from },
        stackToClear,
      },
      { root: true }
    )
  },

  updateTitle({ commit, dispatch, getters }, { id = null, value = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    const oldValue = getters.objectById(id).title
    commit('updateTitle', { id, value })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/updateTitle',
        params: { id, value: oldValue },
        stackToClear,
      },
      { root: true }
    )
  },

  updateTabItems(
    { commit, dispatch, getters },
    { id = null, path = null, value = null, stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    if (!id) {
      return
    }

    const oldValue = lodashGet(getters.objectById(id), `items${path && `.${path}`}`)
    commit('updateTabItems', { id, path, value })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/updateTabItems',
        params: { id, path, value: oldValue },
        stackToClear,
      },
      { root: true }
    )
  },
}
